module.exports = __webpack_public_path__ + "img/8_d.2bfe1027.jpg";